import { render, staticRenderFns } from "./helpList.vue?vue&type=template&id=58976947&scoped=true&"
import script from "./helpList.vue?vue&type=script&lang=js&"
export * from "./helpList.vue?vue&type=script&lang=js&"
import style0 from "./helpList.vue?vue&type=style&index=0&id=58976947&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58976947",
  null
  
)

export default component.exports